import { Internationalization } from '@syncfusion/ej2-base';
import { createRoot } from 'react-dom/client';
import { HiOutlineClock, HiOutlineMapPin, HiOutlineUser } from 'react-icons/hi2';
import {
    isCompactSchedulerEvent,
    isDarkEventColor,
    isOnlineMeeting,
    typeChoiceForUi,
} from './schedulerForm.js';
import { SCHEDULE_TYPE_CHOICES } from './schedulerForm.js';

const instance = new Internationalization();

const getTimeString = (value) => instance.formatDate(value, { skeleton: 'hm' });

const typeLabel = (scheduleType) => (
    SCHEDULE_TYPE_CHOICES.find((choice) => choice.id === typeChoiceForUi(scheduleType))?.label || ''
);

const locationLabel = (props) => {
    if (isOnlineMeeting(props.ScheduleType, props.MeetingData?.mode)) {
        if (props.MeetingData?.platform === 'GOOGLE_MEET') {
            return 'Google Meet';
        }
        if (props.MeetingData?.platform === 'ZOOM') {
            return 'Zoom';
        }
        return 'Online';
    }
    return props.Venue || '';
};

const SchedulerEventTemplate = (props, currentView = 'Day') => {
    const fill = props.SecondaryColor || props.CategoryColor || '#92d841';
    const monthView = currentView === 'Month';
    const compact = monthView || isCompactSchedulerEvent(props.StartTime, props.EndTime, currentView);
    const place = locationLabel(props);
    const type = typeLabel(props.ScheduleType);
    const timeRange = `${getTimeString(props.StartTime)} – ${getTimeString(props.EndTime)}`;
    const description = String(props.Description || '').trim();

    return (
        <div
            className={[
                'template-wrap sm-scheduler-event',
                isDarkEventColor(fill) ? 'sm-scheduler-event-dark' : '',
                compact ? 'is-compact' : 'is-hour',
                monthView ? 'is-month' : '',
            ].filter(Boolean).join(' ')}
            style={{ background: fill }}
        >
            <div className="sm-scheduler-event-main">
                <p className="sm-scheduler-event-title">{props.Subject}</p>
                {monthView ? null : compact ?
                    <p className="sm-scheduler-event-meta">
                        {[timeRange, place].filter(Boolean).join(' · ')}
                    </p>
                    :
                    <>
                        <p className="sm-scheduler-event-meta">
                            {[type, timeRange].filter(Boolean).join(' · ')}
                        </p>
                        {place &&
                            <p className="sm-scheduler-event-place">
                                <HiOutlineMapPin />
                                <span>{place}</span>
                            </p>}
                        {description &&
                            <p className="sm-scheduler-event-desc" title={description}>{description}</p>}
                    </>}
            </div>
            {!compact && props?.IsRSVP &&
                <div className="sm-scheduler-event-rsvp">
                    <span title="Joined"><HiOutlineUser />{props?.AcceptedUser ?? 0}</span>
                    <span title="Pending"><HiOutlineClock />{props?.PendingUser ?? 0}</span>
                </div>}
        </div>
    );
};

const eventRoots = new WeakMap();

export const mountSchedulerEventCard = (element, props, currentView = 'Day') => {
    if (!element) {
        return;
    }
    element.style.backgroundColor = 'transparent';
    element.style.border = '0';
    let host = element.querySelector('.sm-scheduler-event-host');
    if (!host) {
        const details = element.querySelector('.e-appointment-details') || element;
        host = document.createElement('div');
        host.className = 'sm-scheduler-event-host';
        host.style.height = '100%';
        details.innerHTML = '';
        details.appendChild(host);
    }
    let root = eventRoots.get(host);
    if (!root) {
        root = createRoot(host);
        eventRoots.set(host, root);
    }
    root.render(SchedulerEventTemplate(props, currentView));
};

export default SchedulerEventTemplate;
